<template>
	<div>
		<h5>OperationModeManagement</h5>
	</div>
</template>

<script>
	export default {
		name: "OperationMode",
	};
</script>

<style scoped></style>
